import { h } from '@stencil/core';
import cn from 'classnames';
export class PesSoftwareModalHeaderRow {
  constructor() {
    this.columns = [];
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("div", { class: "pes-software-modal-header-row" }, this.columns.map(({ type, label }, index) => (h("pes-software-modal-header-cell", { label: label, index: index, class: cn('pes-software-modal-header-row__cell', type && `pes-software-modal-header-row__cell--${type}`) })))));
  }
  static get is() { return "pes-software-modal-header-row"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-software-modal-header-row.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-software-modal-header-row.css"]
    };
  }
  static get properties() {
    return {
      "columns": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "ReadonlyArray<PESSoftwareModalColumn>",
          "resolved": "readonly PESSoftwareModalColumn[]",
          "references": {
            "ReadonlyArray": {
              "location": "global"
            },
            "PESSoftwareModalColumn": {
              "location": "import",
              "path": "../pes-software-modal-content/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Array of columns in the row"
        },
        "defaultValue": "[]"
      }
    };
  }
  static get elementRef() { return "el"; }
}
